import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import SelectEconomic from '../common/select-filters/SelectEconomic';
import CountryProfileTextTab from '../common/CountryProfileTextTab';
import Methodology from '../common/Methodology';
import Related from '../common/Related';

import { getCountryProfileData } from '../../api';
import { countryProfile } from '../../model/subMenuTabs';

import { setCountry1, setCountry2, setCountry3 } from '../../actions/';

const CountryProfile = props => {

	let selected = "";
	for (let i = 0; i < countryProfile.length; i++)
	{
		if (countryProfile[i].url == props.indicator)
		{
			selected = countryProfile[i];
		}
	}

	const currentPath = '/osh-steering/country-profile/';

	// Get global state for the selects
	const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = useSelector((state) => state.selectCountries);
	const [countryLocked, setCountryLocked] = useState(lockedCountry);
	const [countryProfileData1, setCountryProfileData1] = useState({});
	const [countryProfileData2, setCountryProfileData2] = useState({});
	const [countryProfileData3, setCountryProfileData3] = useState({});
	const [selectedTab, setSelectedTab] = useState(selected);

	// Hook for the dispatchs
	const dispatch = useDispatch();

	const retrieveCountryProfileData = () => {
		const selectCountry1 = selectedByUser ? countryLocked : selectCountry;
		getCountryProfileData(selectCountry1)
		.then((res) => {
			setCountryProfileData1(res.resultset[0]);
		});

		if (selectCountry2 != undefined && selectCountry2 != '')
		{
			getCountryProfileData(selectCountry2)
			.then((res) => {
				setCountryProfileData2(res.resultset[0]);
			});
		}
		else
		{
			setCountryProfileData2({})
		}

		if (selectCountry3 != undefined && selectCountry3 != '')
		{
			getCountryProfileData(selectCountry3)
			.then((res) => {
				setCountryProfileData3(res.resultset[0]);
			});
		}
		else
		{
			setCountryProfileData3({})
		}
	}

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22007 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		retrieveCountryProfileData();
	}, [])

	useEffect(() => {
		retrieveCountryProfileData();
	}, [selectCountry, selectCountry2, selectCountry3, countryLocked, selectedByUser])

	// TBD: Change classes when the third country is added to the visualisation
	const isOneCountrySelected = () => {
		if( selectCountry2 !== undefined && selectCountry2 !== null && selectCountry2 !== ""){
			return "no-full";
		}else{
			return "full";
		}
	}

	// Handle change event for the select box 1
	const handleChangeSelect1 = (callbackCountry1) => {
		if (selectedByUser) {
			setCountryLocked(callbackCountry1);
		} else {
			dispatch(setCountry1(callbackCountry1));
		}
	}

	// Handle change event for the select box 2
	const handleChangeSelect2 = (callbackCountry2) => {
		dispatch(setCountry2(callbackCountry2));
	}

	// Handle change event for the select box 3
	const handleChangeSelect3 = (callbackCountry3) => {
		dispatch(setCountry3(callbackCountry3));
	}

	const callbackSelectedTab = (callback) => {
		for (let i = 0; i < countryProfile.length; i++)
		{
			if (callback == countryProfile[i].url)
			{
				setSelectedTab( countryProfile[i] );
			}
		}
	}

	const selectCountry1 = selectedByUser ? countryLocked : selectCountry;
		
	let subMenuTabs = countryProfile;
	if (selectCountry1 == "EU27_2020" && selectCountry2 == null && selectCountry3 == null)
	{
		// Only EU27 selected, hide the "Relation to EU Strategic Framework" tab (the last one)
		subMenuTabs.pop();
	}

	return(
		<div className="country--profile--page">
			<AdviceSection literals={ props.literals } section={["osh-steering","country-profile"]} methodologyData={{ section: 'osh-steering', subsection: 'Structure of each National strategy', indicator: 46 }} />

			{
				selectCountry1 != "EU27_2020" && 
				<div className="container">
					<p className="btn--block-full left-text">
						<Link to={"/osh-steering/eu-challenges-response/"+selectCountry1} className="btn-default btn-main-color" 
							title={ props.literals.L20625 }>{ props.literals.L20625 }</Link>
					</p>
				</div>
			}

			<div>
				<SubMenuTabs 
					literals={ props.literals } 
					selectedTab={ selectedTab.url }
					callbackSelectedTab={ callbackSelectedTab }
					locationPath={ currentPath } 
					subMenuTabs={ subMenuTabs }						
					selectCountry1={ selectCountry1 }
					selectCountry2={ selectCountry2 }
					selectCountry3={ selectCountry3 }
				/>
			</div>

			<div className="line background-main-light"></div>

			<div>
				<SelectEconomic 
					handleSearch={ handleChangeSelect1 }
					handleSearch2={ handleChangeSelect2 }
					handleSearch3={ handleChangeSelect3 }
					selectedCountry1={ selectCountry1 }
					selectedCountry2={ selectCountry2 }
					selectedCountry3={ selectCountry3 }
					literals={ props.literals }
				/>
			</div>

			<div className="line background-main-light"></div>

			<section className="container section--page full-tablet">
				{ countryProfileData1.country && countryProfile.map( (element) => {
					if (element.url ==  selectedTab.url)
					{
						return (
							<CountryProfileTextTab 
								literals={ props.literals } 
								country1Text={ countryProfileData1[`text${ selectedTab.textIndex }`]} 
								country2Text={ countryProfileData2[`text${ selectedTab.textIndex }`]}
								country3Text={ countryProfileData3[`text${ selectedTab.textIndex }`]}
								country1={ countryProfileData1.country } 
								country2={ countryProfileData2.country } 
								country3={ countryProfileData3.country } 
								tabName={ element.literalTab } 
								key={ selectedTab }
							/>
						)
					}
				} ) }					
			</section>

			<Methodology literals={ props.literals } section={'Structure of each National strategy'} indicator={ selectedTab.indicator } />

			{( selectedTab.url == 'background' 
				|| selectedTab.url == 'actors-and-stakeholders' 
				|| selectedTab.url == 'resources-and-timeframe' 
				|| selectedTab.url == 'relationship-to-eu-strategic-framework') 
				&& (
				<Related literals={ props.literals } section={["osh-steering", "country-profile", selectedTab.url]} country1={ selectCountry1 } country2={ selectCountry2 } country3={ selectCountry3 } />
			)}			
		</div>
	)
}

CountryProfile.displayName = 'CountryProfile';
export default CountryProfile;